export const THEME_PREFERENCES_VERSION = 1;
export const THEME_PREFERENCES_STORAGE_KEY = `cr_theme_mode_v${THEME_PREFERENCES_VERSION}`;
